import Link from 'next/link';

export default function AuthLegalNotice({
  className = '',
  variant = 'signup',
}: {
  className?: string;
  /** Sign-in-only forms cannot create an account, so they only reference the terms. */
  variant?: 'signup' | 'signin';
}) {
  return (
    <p className={className}>
      {variant === 'signin'
        ? 'By signing in, you agree to our '
        : 'By creating an account, you confirm you are at least 18 years old and agree to our '}
      <Link
        href="/legal/terms"
        prefetch={false}
        className="underline underline-offset-4 hover:text-slate-400"
      >
        Terms of Service
      </Link>{' '}
      and{' '}
      <Link
        href="/legal/privacy"
        prefetch={false}
        className="underline underline-offset-4 hover:text-slate-400"
      >
        Privacy Policy
      </Link>
      .
    </p>
  );
}
